import { UaHelper } from './ua-helper.js';

export type BuildType = 'stable' | 'beta' | 'internal' | 'canary';

export type BUILD_CONFIG_TYPE = {
  debug: boolean;
  distribution: 'web' | 'desktop' | 'admin' | 'mobile';
  /**
   * 'web' | 'desktop' | 'admin'
   */
  isDesktopEdition: boolean;
  /**
   * 'mobile'
   */
  isMobileEdition: boolean;

  isElectron: boolean;
  isWeb: boolean;
  isMobileWeb: boolean;

  // this is for the electron app
  /**
   * @deprecated need to be refactored
   */
  serverUrlPrefix: string;
  appVersion: string;
  editorVersion: string;
  appBuildType: BuildType;

  // see: tools/workers
  imageProxyUrl: string;
  linkPreviewUrl: string;

  // payment
  paymentUrl: string;
};

export type Environment = {
  // Device
  isLinux: boolean;
  isMacOs: boolean;
  isIOS: boolean;
  isSafari: boolean;
  isWindows: boolean;
  isFireFox: boolean;
  isMobile: boolean;
  isChrome: boolean;
  isPwa: boolean;

  chromeVersion?: number;
};

export function setupGlobal() {
  if (globalThis.$AFFINE_SETUP) {
    return;
  }

  let environment: Environment;

  if (!globalThis.navigator) {
    environment = {
      isLinux: false,
      isMacOs: false,
      isSafari: false,
      isWindows: false,
      isFireFox: false,
      isChrome: false,
      isIOS: false,
      isPwa: false,
      isMobile: false,
    };
  } else {
    const uaHelper = new UaHelper(globalThis.navigator);

    environment = {
      isMobile: uaHelper.isMobile,
      isLinux: uaHelper.isLinux,
      isMacOs: uaHelper.isMacOs,
      isSafari: uaHelper.isSafari,
      isWindows: uaHelper.isWindows,
      isFireFox: uaHelper.isFireFox,
      isChrome: uaHelper.isChrome,
      isIOS: uaHelper.isIOS,
      isPwa: uaHelper.isStandalone,
    };
    // Chrome on iOS is still Safari
    if (environment.isChrome && !environment.isIOS) {
      environment = {
        ...environment,
        isSafari: false,
        isFireFox: false,
        isChrome: true,
        chromeVersion: uaHelper.getChromeVersion(),
      };
    }
  }

  globalThis.environment = environment;

  setupRuntimeEnv();

  globalThis.$AFFINE_SETUP = true;
}

// добавить тип в json-schema - runtimeenvschema.json
export type RuntimeEnv = {
  DNB_APP_BUILD_TYPE: BuildType;
  DNB_MARKETING_CONSENT_URL: string;
  DNB_LEGAL_AGREEMENT_URL: string;
  DNB_LEGAL_POLICY_URL: string;
  DNB_REQUIRED_AUTH: boolean;
  SENTRY_ENABLED: boolean;
  SENTRY_FEEDBACK_ENABLED: boolean;
  SENTRY_DSN?: string;
  SENTRY_RELEASE?: string;
  DNB_YANDEX_METRIC: string;
};

export function setupRuntimeEnv() {
  const runtimeEnv = globalThis.runtimeEnv;

  runtimeEnv.DNB_APP_BUILD_TYPE =
    runtimeEnv.DNB_APP_BUILD_TYPE ?? BUILD_CONFIG.appBuildType;
  runtimeEnv.DNB_MARKETING_CONSENT_URL =
    runtimeEnv.DNB_MARKETING_CONSENT_URL ??
    'https://app.docnboard.mkskom.ru/workspace/cba66c0f-e15c-4c79-83e3-a1ce70f5b6a9/Qskq6j740N4dPE3JE1Nk5';
  runtimeEnv.DNB_LEGAL_AGREEMENT_URL =
    runtimeEnv.DNB_LEGAL_AGREEMENT_URL ?? 'https://mkskom.ru/policy-agree';
  runtimeEnv.DNB_LEGAL_POLICY_URL =
    runtimeEnv.DNB_LEGAL_POLICY_URL ?? 'https://mkskom.ru/policy-privacy';
  runtimeEnv.DNB_REQUIRED_AUTH = runtimeEnv.DNB_REQUIRED_AUTH ?? false;
  runtimeEnv.SENTRY_ENABLED = runtimeEnv.SENTRY_ENABLED ?? false;
  runtimeEnv.SENTRY_FEEDBACK_ENABLED =
    runtimeEnv.SENTRY_FEEDBACK_ENABLED ?? false;
  runtimeEnv.SENTRY_RELEASE = window.SENTRY_RELEASE?.id;
  runtimeEnv.DNB_YANDEX_METRIC = runtimeEnv.DNB_YANDEX_METRIC ?? '';
}
